<template>
  <vx-card class="w-full mb-5">
    <template slot="no-body">
      <div class="w-full flex flex-col p-3">
        <div class="w-full flex justify-between">
          <div class="text-xl font-semibold">
            {{ timeNow | indonesian_day }},
            {{ timeNow | indonesian_date }}
          </div>
          <div>
            <vs-chip :color="type.color">{{type.name}}</vs-chip>
          </div>
        </div>
        <vs-divider class="mt-2"></vs-divider>
        <div class="w-full flex my-2 ">
          <div class="flex  flex-1">
            <div class="mr-2">
              <vs-avatar
                color="success"
                icon-pack="feather"
                icon="icon-check"
              ></vs-avatar>
            </div>
            <div class="flex flex-col">
              <div>Waktu Mulai</div>
              <div class="text-lg font-bold text-success">
                {{timeIn}}
              </div>
            </div>
          </div>
          <div class="flex  flex-1 justify-end">
            <div class="mr-2">
              <vs-avatar icon-pack="feather" icon="icon-check"></vs-avatar>
            </div>
            <div class="flex flex-col ">
              <div>Waktu Selesai</div>
              <div class="text-lg font-bold text-success">
                {{timeOut}}
              </div>
            </div>
          </div>
        </div>
        <div class="w-full mt-3 vs-row flex justify-between">
          <vs-chip v-for="(chip, i) in clockIn" :key="'clockIn'+i" :color="chip.color" class="vs-col ">
            <vs-avatar
              icon-pack="feather"
              icon="icon-alert-circle"
             :color="chip.color"
            />
            <span>{{chip.name}}</span>
          </vs-chip>
          <vs-chip v-for="(chip, i) in clockOut" :key="'clockOut'+i" :color="chip.color" class="vs-col ">
            <vs-avatar
              icon-pack="feather"
              icon="icon-alert-circle"
              :color="chip.color"
            />
            <span>{{chip.name}}</span>
          </vs-chip>
        </div>
      </div>
    </template>
  </vx-card>
</template>

<script>
import moment from "moment";
export default {
  props: {
    attendance : {
      type: Object
    }
  },
  data() {
    return {
     
    };
  },
  computed:{
    timeIn() {
      return this.attendance.jam_mulai
    },
    timeOut() {
      return this.attendance.jam_selesai == null ? '--:--' : this.attendance.jam_selesai
    },
    timeNow() {
      return moment(this.attendance.created_at)
    },
    clockIn() {
      let chips = [];
      if(this.attendance.tipe) {
        if(this.attendance.tipe.clock_in) {
          this.attendance.tipe.clock_in.split(',').map(i => {
            if(i == 'late') {
                chips.push({
                name: "Telat Datang",
                color: 'warning'
              })
            }
            
          })
        }
      }
      return chips;
    },
    clockOut(){
      let chips = [];
      if(this.attendance.tipe) {
        if(this.attendance.tipe.clock_out) {
          this.attendance.tipe.clock_out.split(',').map(i => {
            if(i == 'early_clock_out') {
                chips.push({
                name: "Selesai Lebih Awal",
                color: 'warning'
              })
            }
            
          })
        }
      }
      return chips;
    },
    type() {
      return this.attendance.keterangan == 'Work From Home (WFH)' ? {name: 'WFH', color: 'primary'} : {name: 'WFO', color: 'success'}
    }
  }
};
</script>
